import { render } from "./Home.vue?vue&type=template&id=b18dfe7e"
const script = {}
script.render = render

export default script